<div class="col-xs-12 ticket-details">
  <div class="ticket-details-header">
    <span *ngIf="editMode">
      Edit Ticket Details
      <b data-testid="sbar-history" class="fontS1 bold icon-color" *ngIf="ticket?.get('SBAR')" (click)="openSbarHistory()">SBAR History</b>
    </span>
  </div>
  <div class="ticket-details-body">
    <div *ngIf="!editMode">
      <div class="split">
        <div class="col-xs-6 details-section">
          <div class="details-body">
            <div class="body-block">
              <div class="flex w100 justifySB">
                <h4><b class="fw-700">Title:</b> {{ticket?.get('title') || ticket?.get('titleLanguageString')?.get('en')}}</h4>
              </div>
              <div class="flex flex-dir-col alignFS gap-12">
                @for (key of getKeys(ticket.get('operatorAnalysisResponse')); track key.name) {
                  <span *ngIf="ticket.get('operatorAnalysisResponse')[key]">
                    <b>{{ formatKey(key) }}:</b> {{ ticket.get('operatorAnalysisResponse')[key]}}
                  </span>
                }
                <b *ngIf="ticket.get('status') === apiClientConstant.SupportTicket.Status.Pending" class="icon-color underline" data-testid="ticket-edit" (click)="toggleEditMode()">Edit</b>
                <span class="flex gap-12">
                  <b class="fas fa-history icon-color" (click)="openTicketHistory(ticket)"></b>
                  <b data-testid="analysis-history" class="fa fa-sticky-note icon-color" (click)="openOperatorAnalysisHistory(ticket)"></b>
                  <b data-testid="sbar-history" class="fontS1 bold icon-color" *ngIf="ticket?.get('SBAR')" (click)="openSbarHistory()">SBAR History</b>
                </span>
              </div>
            </div>
          </div>
          <div class="details-footer">
            <div class="w100 flex flex-dir-col alignFS">
              <p><b>Created by:</b> {{ ticket?.get('createdBy')?.get('username')}} </p>
              <p><b>Status:</b> {{ ticket?.get('status') }}</p>
              <p *ngIf="ticket?.get('teams')?.length > 0"><b>Assigned Team:</b> {{ ticket?.get('teams')[0] }} <span *ngIf="allocatedTo">({{allocatedTo}})</span></p>
            </div>
            <div>
              <span data-testid="ticket-mark-unattended" *ngIf="ticket?.get('attended')" class="underline bold icon-color" (click)="updateTicketAttendedStatus(false)"> Mark as unattended </span>
              <span data-testid="ticket-mark-attended" *ngIf="!ticket?.get('attended')" class="underline bold icon-color" (click)="updateTicketAttendedStatus(true)"> Mark as attended </span>
            </div>
          </div>
        </div>
        <div class="col-xs-6 message-section flex flex-dir-col">
          <app-ticket-message class="col-xs-12 h100" #messageSection [patient]="user" [ticket]="ticket" ></app-ticket-message>
        </div>
      </div>
    </div>
    <div *ngIf="editMode">
      <form class="ticket-edit" #TICKET="ngForm" novalidate>
        <div class="col-xs-12" style="display: flex; gap: 10px; margin-bottom: 20px;">
        <div data-testid="analysis-field" class="flex flex-dir-col alignFS">
          <span data-testid="analysis-field-label" class="fontS2">Category</span>
        <select 
          class="custom-select-ticket" 
          name="category" 
          [(ngModel)]="operatorAnalysisResponse.category" 
          (change)="onCategoryChanged($event.target.value)" 
          required>
          <option *ngFor="let category of categories" [value]="category.value">{{category.display}}</option>
        </select>
        </div>
        <div data-testid="analysis-field" class="flex flex-dir-col alignFS" *ngIf="operatorAnalysisResponse.category !== 'default'">
          <span data-testid="analysis-field-label" class="fontS2">Subcategory</span>
          <select class="custom-select-ticket" name="subcategory" [(ngModel)]="operatorAnalysisResponse.subcategory" (change)="onSubcategoryChanged($event.target.value)" required>
            <option *ngFor="let subcategory of subcategories" [value]="subcategory.value">{{subcategory.display}}</option>
          </select>
        </div>
      </div>
      <div *ngIf="this.operatorAnalysisResponse.category && dynamicFields.length > 0" 
        class="col-xs-12" 
        style="display: flex; gap: 20px; margin-bottom: 20px; flex-flow: wrap;">
     <ng-container *ngFor="let field of dynamicFields">
      <div data-testid="analysis-field" class="flex flex-dir-col alignFS">
        <span *ngIf="field.name !== 'otherProducts' && field.name !== 'callStatus'" data-testid="analysis-field-label" class="fontS2">{{field.label}}</span>
        <select 
          *ngIf="field.type === 'select' && field.name !== 'callStatus'"
          [name]="field.name"
          class="custom-select-ticket" 
          [(ngModel)]="operatorAnalysisResponse[field.name]" 
          required>
          <option *ngFor="let option of field.options" [value]="option.value">{{option.display}}</option>
        </select>
        <span *ngIf="field.name === 'otherProducts'" data-testid="analysis-field-label" class="fontS2">{{field.label}}</span>
        <div *ngIf="field.type === 'radio' && field.name !== 'otherProducts'" class="flex gap-12">
          <div class="flex gap-4">
          <label class="m0">Yes</label>
          <input class="radio-input"
            type="radio" 
            [name]="field.name" 
            [(ngModel)]="operatorAnalysisResponse[field.name]" 
            [value]="true" 
            checked
            required /> 
          </div>
          <div class="flex gap-4">
            <label class="m0">No</label>
          <input class="radio-input"
            type="radio" 
            [name]="field.name" 
            [(ngModel)]="operatorAnalysisResponse[field.name]" 
            [value]="false"
            required /> 
          </div>
        </div>
        <div *ngIf="field.type === 'radio' && field.name === 'otherProducts'" class="flex gap-12">
          <div class="flex gap-4">
          <label class="m0">Yes</label>
          <input class="radio-input"
          type="radio" 
          [name]="field.name" 
          [(ngModel)]="operatorAnalysisResponse[field.name]" 
          [value]="true" 
          (change)="addProductsUsedField(true)" 
          required
          checked /> 
          </div>
          <div class="flex gap-4">
          <label class="m0">No</label>
          <input class="radio-input"
          type="radio" 
          [name]="field.name" 
          [(ngModel)]="operatorAnalysisResponse[field.name]" 
          [value]="false" 
          (change)="addProductsUsedField(false)"
          required /> 
          </div>  
        </div>
        <span *ngIf="field.name === 'callStatus'" data-testid="analysis-field-label" class="fontS2">{{field.label}}</span>
        <select 
          *ngIf="field.type === 'select' && field.name === 'callStatus'"
          [name]="field.name"
          class="custom-select-ticket" 
          [(ngModel)]="operatorAnalysisResponse[field.name]"
          (change)="onCallStatusChange($event.target.value)"
          required>
          <option *ngFor="let option of field.options" [value]="option.value">{{option.display}}</option>
        </select>
        <textarea 
            *ngIf="field.type === 'textArea'" 
            [name]="field.name"
            class="custom-textArea" 
            [(ngModel)]="operatorAnalysisResponse[field.name]" 
            [placeholder]="field.placeholder" 
            required>
          </textarea>
          <input 
            *ngIf="field.type === 'text'" 
            type="text" 
            [name]="field.name"
            class="custom-select-ticket" 
            [(ngModel)]="operatorAnalysisResponse[field.name]" 
            [placeholder]="field.placeholder" 
            required/>
      </div>
    </ng-container>
  </div>
      <div class="col-xs-12 mT20">
        <button class="btn-submit" type="submit" [disabled]="!TICKET.valid" (click)="saveTicketDetails()">Save Details</button>
      </div>
      </form>
    </div>
  </div>
</div>

